enum DataType {
  STRING = 'String',
  BOOLEAN = 'Boolean',
  DATE = 'Date',
  NUMBER = 'Number',
  OBJECT = 'Object',
  ARRAY = 'Array',
  UNKNOWN = 'Unknown',
  STRUCTURE = 'Structure',
}

export default DataType;
